import { call, put } from "redux-saga/effects";

import {
  LoginApi,
  checkUserNameApi,
  getCurrentUserApi,
  getHelpicalTokenApi,
  loginUserByKeyApi,
} from "../../../Connections/APIs/Login";

import {
  getCurrentUserFailAction,
  loginUserByKeyFailAction,
  loginDispatcherFailAction,
  getCurrentUserSuccessAction,
  loginUserByKeySuccessAction,
  loginDispatcherSuccessAction,
  checkUserNameExistFailAction,
  checkUserNameExistSuccessAction,
  getHelpicalTokenSuccessAction,
  getHelpicalTokenFailAction,
} from "../../Actions/Auth/Actions";

export function* getUserSaga() {
  try {
    const response = yield call(getCurrentUserApi);
    yield put(getCurrentUserSuccessAction(response.data.entity));
  } catch (error) {
    yield put(getCurrentUserFailAction(error));
  }
};

export function* loginUserByKeySaga(action) {
  try {
    const response = yield call(loginUserByKeyApi, action.data);
    yield put(loginUserByKeySuccessAction(response.data.entity));
  } catch (error) {
    yield put(loginUserByKeyFailAction(error));
  }
};

export function* checkUserNameSaga(action) {
  try {
    const response = yield call(checkUserNameApi, action.data);
    yield put(checkUserNameExistSuccessAction(response.data));
  } catch (error) {
    yield put(checkUserNameExistFailAction(error));
  }
};


export function* loginUserSaga(action) {
  try {
    const response = yield call(LoginApi, action.data);
    yield put(loginDispatcherSuccessAction(response.data));
  } catch (error) {
    console.dir(error)
    yield put(loginDispatcherFailAction(error));
  }
}


export function* getHelpicalTokenSaga(action) {
  try {
    const response = yield call(getHelpicalTokenApi, action.data);
    yield put(getHelpicalTokenSuccessAction(response.data));
  } catch (error) {
    console.dir(error)
    yield put(getHelpicalTokenFailAction(error));
  }
}